/**
 * @module Venue
 */

import { path, assocPath } from 'ramda';
import { createSchemaBasedConstructor } from './create-typed-constructor';

const Venue = createSchemaBasedConstructor('Venue');

/*
 * In general, we expect "Venue Details" returned from our servers to include some data that's entered by
 * Map designers and some that's added in as part of asset generation. In this tool, we have not yet been
 * through asset generation so we need to enrich the Venue Details ourselves. Fortunately the AI JSON file
 * has all the data we need to do this.
 *
 * In particular, these are normally added by asset generation:
 *
 * - the viewBox (half the data needed to convert from AI coordinates to LatLng's)
 * - boundsPolygons for each level in each building (which is explicitly defined by the Map Designers)
 *
 * @sig enrichVenueDetailsFromAiJson :: (VenueId, VenueData, AiJson) -> VenueData
 */
Venue.enrichVenueDetailsFromAiJson = (venueId, venueData, aiJson) => {
    const viewBox = () => ({
        x: 0,
        y: 0,
        width: path(['properties', 'width'], aiJson),
        height: path(['properties', 'height'], aiJson),
    });

    // now update the venueData
    venueData = assocPath(['fixedGeometry', 'viewBox'], viewBox(aiJson), venueData);

    return venueData;
};

Venue.getVenueCenter = venue => {
    const { venueCenter } = venue;
    const { lat: latitude, lng: longitude } = venueCenter;
    return { latitude, longitude };
};

export default Venue;
